import React from 'react';
import useRecentlyViewedItems from '@sls-react/hooks/useRecentlyViewedItems';
import HorizontalScrollItemGrid from '@sls-react/components/legos/HorizontalScrollItemGrid';
import BlockSection from '@sls-react/components/legos/BlockSection';
import { RailsBlock } from '@sls-react/typings/services/rails/tile';
import ItemThumbnail from '@sls-react/components/ItemThumbnail/ItemThumbnail';
import useItemGridMeta from '@sls-react/hooks/useItemGridMeta';

interface Props {
  block: RailsBlock;
  headerType?: 'h1' | 'h2' | 'h3';
}

const RecentlyViewedItemBlock: React.FC<Props> = ({ block, headerType }) => {
  const { data } = useRecentlyViewedItems(20);
  useItemGridMeta(data);

  if (!data) {
    return null;
  }

  if (data.length === 0) {
    return null;
  }

  return (
    <BlockSection block={block} headerType={headerType}>
      <HorizontalScrollItemGrid>
        {data.map(item => (
          <ItemThumbnail key={item.id} item={item} />
        ))}
      </HorizontalScrollItemGrid>
    </BlockSection>
  );
};

export default RecentlyViewedItemBlock;
